import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./i18n/en.json";
import it from "./i18n/it.json";
import es from "./i18n/es.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      it: { translation: it },
      es: { translation: es }
    },
    fallbackLng: "en",
    supportedLngs: ["en", "it", "es"],

    detection: {
      // 1) user choice (localStorage), 2) browser, 3) <html lang="">
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"]
    },

    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
